import loadScript from "./loadScript.mjs";
import { logger } from "./logger.mjs";
const resolveKlarnaOsmScript = (src, attrs, fnOverrides = { ls: loadScript, lg: logger }) => new Promise((resolve, reject) => {
  const {
    ls = loadScript,
    lg = logger
  } = fnOverrides;
  ls(src, attrs).then(({ timing }) => {
    lg.log("KlarnaOsm - script load", {
      start: timing.start,
      finish: timing.finish,
      duration: timing.finish - timing.start
    });
    resolve();
  }).catch((error) => {
    lg.error("KlarnaOsm - script load error", error);
    reject();
  });
});
export {
  resolveKlarnaOsmScript as default
};
//# sourceMappingURL=klarna.mjs.map
